import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'components_phone_collection_block';

let ids = {
  PHONE: 'PHONE',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_PHONE_COLLECTION_BLOCK_IDS = ids;
export const T_PREFIX = 'products-fe.components.phone_collection_block';
